import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as S from './styles';
import { initDescriptionExpansionBasedOnContentHeight } from './desciptionExpansion';

const CollapsableText = ({ children }) => {
    const collapsableTextContent = useRef();

    useEffect(() => {
        initDescriptionExpansionBasedOnContentHeight(collapsableTextContent);
    }, []);

    return (
        <S.Wrapper className="my-32">
            <S.Content ref={collapsableTextContent} maxHeight={500} data-max-height={500}>
                {children}
            </S.Content>
        </S.Wrapper>
    );
};

CollapsableText.propTypes = {
    children: PropTypes.node,
};

export default CollapsableText;
